<template>
	<div id="tickets" class="base bg-blur">
		<div class="inner">
			<div class="header">
				<h2 class="title">Kartenverkauf und Abholung</h2>
				<p class="subtitle">
					Der Kartenverkauf ist noch nicht geöffnet
				</p>

				<FancyButton v-if="false" link="Tickets" text="Jetzt reservieren" @click="" />
			</div>
			<div class="content">
				<p>
					Der Kartenverkauf wird etwa 2 Wochen vor dem Ball geöffnet.
				</p>
				<p>
					Die Online-Reservierung startet einen Monat vor dem Ball, am 8. Mai.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import FancyButton from "../FancyButton.vue";
export default {
	components: { FancyButton },
	setup() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.list {
	list-style: none;
}
</style>